import React, { Component } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth } from "../Helpers/SettingHelper";
import { apiUrl} from'../Config/Config';
import axios from 'axios';

const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();

	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
	  />
	);
  };

class Edit extends Component {

	constructor(props)
	{
		CheckAuth();
		super(props);
		const CategoryId = (typeof props.params.ID === 'undefined') ? '' : props.params.ID;
		this.state = {
			name:'',
			status:'',
			Loading:false,
			selectedvalue: '',
            selectedOption:{ value: 'active', label: 'Active'},
			statusmessage:'',
			category_id: CategoryId,
			priority:"",
		};

		axios.get(apiUrl+"VehicleCategory/listdetail?id="+this.state.category_id).then(res => {
			if(res.data.status === "success"){

				const formdata = res.data.category;
				if(formdata.status === 'A'){
					this.setState({selectedOption:{value: 'active', label: 'Active'}});
				}else{
					this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
				}
				this.setState({name:formdata.cate_name,priority:formdata.priority,selectedvalue:formdata.status == 'A' ? 'active' : 'inactive'});
			}
		});

		this.handleInputChange = this.handleInputChange.bind(this);
	    this.handleChange = this.handleChange.bind(this);

    }

    handleChange = selectedOption => {
        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
    };

   handleInputChange(event) {

      const {name, value} = event.target;
      this.setState({
          [name]: value
        });
    }

	componentDidMount() {
		document.title = PageTitle('Credit Card Category Edit');
    }

        handleFormSubmit = () => {
			if(this.validateForm()){
				this.setState({Loading:true});
				const formPayload = this.state;
				var qs = require('qs');
				var status = '';
				if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
				status =formPayload.selectedOption.value;
				}else{
				status = formPayload.selectedvalue;
				}
				var postObject = {
					admin_id : localStorage.getItem("admin_id"),
					id : formPayload.category_id,
					name    : formPayload.name,
					priority : formPayload.priority,
					status       : status,
				};
				axios.post(apiUrl+"VehicleCategory/edit",qs.stringify(postObject)).then(res => {

					if(res.data.status === "success"){
						this.setState({ Loading: false });
						$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');

								setTimeout(
								function() {
									$('.success_message').html('');
									this.props.navigate('/vehiclecategory');
								}
								.bind(this),
								3000
								);
					} else {
						this.setState({ Loading: false });
						$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
							setTimeout(
							function() {
								$('.success_message').html('');
							}
							.bind(this),
							3000
							);
					}
				});
			}
	}

	validateForm() {

		const {name,priority} = this.state;
		let errors = {};
      	let formIsValid = true;

		  if (!name) {
			errors++;
			$('.errorname').html('<span class="errorspan">Please enter the category name</span>');
		}else if(name){
			$('.errorname').html('');
		}

		// if (!priority) {
		// 	errors++;
		// 	$('.errorpriority').html('<span class="errorspan">Please enter the priority</span>');
		// }else if(priority){
		// 	$('.errorpriority').html('');
		// }

		if(errors>0) {

		return false;
		}
		else {
		return true;
		}
    }

  render() {
  	  const {selectedOption} = this.state;

    return (
      <div className="wrapper">

	  <Header />
    <MenuSidebar currentpage="creditcardcategory" currentTab="common" currentSubTab="creditcard-management" />

	<div className="content">
		<div className="content-wrapper">
		<div className="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
			<div className="success_message"></div>
			<div>
				<a className="primary-btn" href="/vehiclecategory">Back</a>
			</div>
			<div className="title">
				<h4>Edit Credit Card Category</h4>
			</div>
			 <form className="login" id="login" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }}>
			<div className="form-row">
			<div className="form-left">
			<div className="form-group">
					<label>Category Name<span className="required" style={{ color: "red" }} >*</span></label>
				    <input type="text" name="name" onChange={this.handleInputChange} className="form-control" value={this.state.name} autoComplete="off" />
					<div className="errorname"></div>
			</div>
			<div className="form-group">
				<label>Priority : </label>
				<input type="text" name="priority" className="form-control" value={this.state.priority}  onChange={this.handleInputChange} autoComplete="off" />
				<div className="errorpriority"></div>
			</div>

			</div>
				<div className="form-left">
					<div className="form-group">
						<label>Status</label>
						<Select
						value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
						options={lang.common.status_option}
						onChange={this.handleChange}
						/>
					</div>

				</div>
			</div>


		<div className="btn-group export">
			  <button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true &&
                                        <span className="load-data"></span>
                                        }Submit
                   </button>
		</div>
		</form>
			</div>

		</div>
	</div>

    </div>
    );
  }
}

export default withRouter(Edit);
